import { render, staticRenderFns } from "./Prets.vue?vue&type=template&id=54781696&scoped=true"
import script from "./Prets.vue?vue&type=script&lang=js"
export * from "./Prets.vue?vue&type=script&lang=js"
import style0 from "./Prets.vue?vue&type=style&index=0&id=54781696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54781696",
  null
  
)

export default component.exports